export default {
  en: {
    headline: 'Home',
    sections: {
      food: 'Food',
      restaurants: 'Restaurants',
      categories: 'Categories',
    },
    promoCarouselAlt: 'Promo',
    categories: {
      favorites: 'Favorites',
      recommended: 'Recommended',
      freeDelivery: 'Free delivery',
      ratingHigh: 'Rating > 4.5',
      fast: 'Fast',
      topReviewed: 'Most reviewed',
      spicy: 'Spicy',
    },
    sort: {
      label: 'Sort',
      orders: {
        default: 'Default',
        'price-asc': 'Price: low to high',
        'price-desc': 'Price: high to low',
      },
    },
    allFood: 'All food',
    allFoodFrom: 'All food from {name} ({count})',
    loadMoreRestaurants: 'Load more restaurants',
    paymentVariantsTitle: 'Payment options',
    paymentCashVnd: 'Cash VND',
    faqPreview: {
      howToPay: 'How can I pay?',
      deliveryLimits: 'Are there delivery restrictions?',
      howItWorks: 'How it works',
    },
    restaurantClosed: 'Closed',
    opensInMinutes: 'opens in {minutes} min',
    opensInHours: 'opens in {hours} h',
    opensInHoursMinutes: 'opens in {hours} h {minutes} min',
    allRestaurants: 'All restaurants',
    restaurantsPlaceholder: 'Restaurant list will appear here.',
    clientLead: 'Order food from restaurants near you.',
    courierLead: 'Delivery tasks and routes.',
    restaurantLead: 'Orders and menu for your venue.',
    adminLead: 'Platform administration.',
  },
  ru: {
    headline: 'Главная',
    sections: {
      food: 'Еда',
      restaurants: 'Рестораны',
      categories: 'Категории',
    },
    promoCarouselAlt: 'Промо',
    categories: {
      favorites: 'Избранные',
      recommended: 'Рекомендация',
      freeDelivery: 'Бесплатная доставка',
      ratingHigh: 'Рейтинг > 4.5',
      fast: 'Быстрые',
      topReviewed: 'Максимум отзывов',
      spicy: 'Острые',
    },
    sort: {
      label: 'Сортировка',
      orders: {
        default: 'По умолчанию',
        'price-asc': 'Сначала дешёвые',
        'price-desc': 'Сначала дорогие',
      },
    },
    allFood: 'Вся еда',
    allFoodFrom: 'Вся еда из {name} ({count})',
    loadMoreRestaurants: 'Загрузить ещё',
    paymentVariantsTitle: 'Варианты оплаты',
    paymentCashVnd: 'Наличные VND',
    faqPreview: {
      howToPay: 'Как можно оплатить?',
      deliveryLimits: 'Есть ли ограничение по доставке?',
      howItWorks: 'Как это работает',
    },
    restaurantClosed: 'Закрыто',
    opensInMinutes: 'откроется через {minutes} мин',
    opensInHours: 'откроется через {hours} ч',
    opensInHoursMinutes: 'откроется через {hours} ч {minutes} мин',
    allRestaurants: 'Все рестораны',
    restaurantsPlaceholder: 'Здесь будет список ресторанов.',
    clientLead: 'Заказывайте еду из ресторанов рядом с вами.',
    courierLead: 'Задания и маршруты доставки.',
    restaurantLead: 'Заказы и меню заведения.',
    adminLead: 'Администрирование платформы',
  },
}
